module.exports = __webpack_public_path__ + "img/office-of-textile.c2ee0642.jpg";